module.exports = __webpack_public_path__ + "img/agency-illustration.ee4335a1.svg";